import { Route } from '@angular/router';
import { roleGuard } from './general/guards/role.guard';
import { MsalGuard } from '@azure/msal-angular';

export const appRoutes: Route[] = [
	{
		path: 'dashboard',
		loadComponent: () =>
			import('./modules/dashboard/dashboard.component').then((m) => m.DashboardComponent),
		canActivate: [MsalGuard, roleGuard],
	},
	{
		path: 'remote',
		loadComponent: () => import('./modules/remote/remote.component').then((m) => m.RemoteComponent),
		canActivate: [MsalGuard, roleGuard],
	},
	{
		path: 'replay',
		loadChildren: () => import('./modules/replay/replay.module').then((m) => m.ReplayModule),
		canActivateChild: [MsalGuard],
	},
	{
		path: '**',
		redirectTo: 'dashboard',
	},
];
